<script lang="ts" setup>
import { ExclamationCircleIcon } from '@heroicons/vue/24/solid';
import { ReplicationNotification } from '@libero/api-client/notification/types';
import Support from '@libero/cityview/modules/support/views/modals/Support.vue';
import Button from '@libero/ui-framework/Button/Button.vue';
import Cluster from '@libero/ui-framework/Cluster/Cluster.vue';
import Stack from '@libero/ui-framework/Stack/Stack.vue';
import Typography from '@libero/ui-framework/Typography/Typography.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { Props } from './BaseNotification.vue';
import BaseNotification from './BaseNotification.vue';

const props = defineProps<Props>();

const { t } = useI18n();

const notification = computed(() => props.notification as ReplicationNotification);
</script>

<template>
  <BaseNotification v-bind="props" :notification="notification">
    <template #icon>
      <ExclamationCircleIcon />
    </template>

    <Stack :gap="0.25">
      <Typography isDark>
        {{ t('notification.replication-failed') }}
      </Typography>

      <Cluster>
        <Support v-slot="{ openModal }">
          <Button size="sm" :onClick="openModal">
            {{ t('support.contact-support') }}
          </Button>
        </Support>
      </Cluster>
    </Stack>
  </BaseNotification>
</template>
